import React from "react";

const CreatorBadge = ({ className }) => {
  return (
    <button
      className={`tw-group tw-flex tw-h-6 tw-items-center tw-justify-center tw-rounded-lg tw-bg-gradient-to-br tw-from-yellow-200 tw-via-amber-400 tw-to-yellow-300 tw-px-2.5 tw-py-0.5 tw-text-[10px] tw-tracking-wider tw-font-black tw-uppercase tw-shadow-md tw-ring-1 tw-ring-yellow-300/50 tw-transition-all tw-duration-200 hover:tw-from-yellow-300 hover:tw-via-amber-400 hover:tw-to-yellow-500 hover:tw-shadow-yellow-400/30 hover:tw-ring-yellow-300/70 tw-border-0 tw-cursor-pointer ${className}`}
      aria-label="Upgrade to Creator Plan"
    >
      <span className="tw-mr-1 tw-text-xs tw-opacity-90 tw-group-hover:tw-animate-pulse">
        💎
      </span>
      <span className="tw-relative">CREATOR</span>
    </button>
  );
};

export default CreatorBadge;
